import styled from "styled-components";
import { CMDiv } from "../login/login.styles";
import WizardModal from "../../../components/wizard-modal/wizard-modal.component";

export const SignupContainer = styled.div(props => ({
    textAlign:"center",
    [`& ${CMDiv}`]: {
        maxWidth: '650px'
    },
    '& .login-form': {
        "@media(max-width: 480px)": {
           width:'100%'
          },
    },

    '& .error-message-validation': {
        maxWidth: "650px",
        width: '80%',
    },

    '& .form-container': {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        flexDirection:'row',
        '@media (max-width: 768px)': {
            flexDirection: 'column', 
        },

        '&.dotted-border': {
            marginBottom: '2rem',
        },

        '&:not(.register)': {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
        },

        '& .form-control': {
            marginBottom: '1rem',
            width: '47% !important',
            display:"flex",
            flexDirection:"column",
            
            '@media (max-width: 1120px)': {
                width: '80% !important',
            },

            '@media (max-width: 400px)': {
                width: '70% !important',
            },

            '&.fullwidth': {
                width: '100% !important'
            },

            '& input::placeholder': {
                color: 'rgba(0, 0, 0, 0.2)',                
            },
           

            '&.user-type': {

                '& .user-type-group': {
                    display: 'flex',
                    marginTop: '1rem',
                    '@media (max-width: 768px)': {
                        flexDirection: 'column', 
                        maxWidth: '100%', 
                    },

                    '& label': {
                        color: '#000',
                        minWidth: '100px',
                        padding: '8px 1.2rem 8px 1rem',
                        borderRadius: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '2rem',
                        border: `solid 1px #acacac`,
                        position: 'relative',
                        marginTop: '60px',

                        '&.checked': {
                            borderColor: props.theme.palette.primary.main,
                        },

                        '& img': {
                            height: '55px',
                            position: 'absolute',
                            top: '-56px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                        },
                    }
                }
            },

            '&.migratory-status': {
                '& label': {
                    marginRight: '1.5rem',
                    display: 'inline-flex',
                    alignItems: 'center'
                },
                '& input[type="radio"]': {
                    marginTop: 0,
                    border: `solid 1px ${props.theme.palette.primary.main}`,
                },

                '& > .migratoryState': {
                    '@media (max-width: 775px)': {
                      display: 'flex', 
                      flexDirection: 'column',
                    },
                },
            },

           

            '& input[type="radio"]': {
                appearance: 'none',
                webkitAppearance: 'none',
                width: '1rem',
                height: '1rem',
                border: '1px solid #acacac',
                borderRadius: '50%',
                marginRight: '10px',
                backgroundColor: 'transparent',
                position: 'relative',

                '&:checked': {
                    borderColor: props.theme.palette.primary.main,
                    backgroundColor: props.theme.palette.primary.main
                }
            }
        },

        '& .field-max':{
            '@media (max-width: 1120px)': {
                maxWidth:"250px"
              },
        },

        '& .checkbox-container': {
            display: 'flex !important',
            alignItems: 'center',

            '& label': {
                color: '#000',
                cursor: 'pointer',
    
                '&.agreement': {
                    width: '1rem',
                    height: '1rem',
                    textAlign: 'center',
                    display: 'inline-block',
                    color: '#000',
                    marginRight: '1rem',
                    border: `solid 1px ${props.theme.palette.primary.main}`,

                    '&.terms': {
                        marginTop: '2rem',
                        marginBottom: '2rem',
                    },
    
                    '&.checked': {
                        backgroundColor: props.theme.palette.primary.main,
                    },
    
                    '& svg': {
                        marginBottom: '2px',
                    },
    
                    '& input': {
                        opacity: 0,
                    }
                }
            }
        },

        '& .dropdown-container': {
            width: '100%'
        },
    },

    '& button': {
        marginTop: '2rem !important'
    },
}));

export const WelcomeModal = styled(WizardModal)(props => ({
    '& .center-absolute': {
        padding: '2rem',

        '& > div': {
            padding: '1rem 0'
        },

        '& .title': {
            textAlign: 'center',
            borderBottom: `solid 1px ${props.theme.palette.primary.main}`
        },

        '& .button-container': {
            marginTop: 0,
            
            '& button': {
                marginRight: '1rem',
                textTransform: 'unset',
            },

            [`@media ${props.theme.breakpoints.sm}`]: {
                dispolay:"felx",
                flexDirection:"column"
            },
        }
    }
}))

export const BackButton = styled.button((props) => ({
    color: props.theme.palette.primary.main,
    borderRadius: "30px",
    borderColor: props.theme.palette.primary.main,
    backgroundColor: "white",
    width: "40px",
    maxWeight: "50px",
    fontSize: "1.5rem",
    transitionDuration: "0.3s",
    '&:hover': {
        backgroundColor: props.theme.palette.primary.main,
        color: "white"
    },
}))

export const HeadContainer = styled.div((props) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexDirection: "row",
    gap: "20px"
}))

export const BTNsmall = styled.div(props =>( {
    '& .btnSubmitSignUp': {
        "@media(max-width: 480px)": {
            width: '100%'
          },
    }
}))

export const CMCloseButton = styled.div((props) => ({
    textAlign: "right",
    position: "absolute",
    right: 32,
    top: 15,
    cursor: "pointer",
    [`@media ${props.theme.breakpoints.md}`]: {
      padding: "20px !important"
    },
    [`@media ${props.theme.breakpoints.sm}`]: {
      padding: "10px !important"
    }
  }));